import axiosInstance from "../../axios";
import axios from "axios";

const PANEL_PACKAGES_CSV_FIELD_NAME = "panel_packages_csv";
const HARDWARE_PACKAGES_CSV_FIELD_NAME = "hardware_packages_csv";

export const getPlacedOrders = () => {
  return axiosInstance.get("/orders/placed");
};

export const updateDeliveryDate = async ({ orderId, deliveryDate }) => {
  return axiosInstance.post(`/orders/${orderId}/update_delivery_date`, {
    delivery_date: deliveryDate,
  });
};

export const updateShipmentDate = async ({
  orderId,
  shipmentId,
  plannedDate,
  final,
  status,
  file,
  panelPackagesFile,
  hardwarePackagesFile,
  reason,
  otp,
  paymentValue,
  paymentDate,
  approveReason,
}) => {
  if (file || panelPackagesFile || hardwarePackagesFile || status === "ready_to_dispatch" || status === "dispatch") {
    const formData = new FormData();
    formData.append("shipment_id", shipmentId);

    if (plannedDate !== null && plannedDate !== undefined) {
      formData.append("planned_date", plannedDate);
    }
    if (final !== null && final !== undefined) {
      formData.append("final", final);
    }
    if (status !== null && status !== undefined) {
      formData.append("status", status);
    }
    // Panel packages CSV - prioritize panelPackagesFile over legacy file parameter
    const panelFile = panelPackagesFile || file;
    if (panelFile) {
      formData.append(PANEL_PACKAGES_CSV_FIELD_NAME, panelFile);
    }
    if (hardwarePackagesFile) {
      formData.append(HARDWARE_PACKAGES_CSV_FIELD_NAME, hardwarePackagesFile);
    }
    if (reason !== null && reason !== undefined) {
      formData.append("reason", reason);
    }
    if (otp !== null && otp !== undefined) {
      formData.append("otp", otp);
    }
    if (paymentValue !== null && paymentValue !== undefined) {
      formData.append("payment_value", paymentValue);
    }
    if (paymentDate !== null && paymentDate !== undefined) {
      formData.append("payment_date", paymentDate);
    }
    if (approveReason !== null && approveReason !== undefined) {
      formData.append("approval_remarks", approveReason);
    }

    return axiosInstance.post(`/orders/${orderId}/update_shipment_date`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  const payload = {
    shipment_id: shipmentId,
  };

  if (plannedDate !== null && plannedDate !== undefined) {
    payload.planned_date = plannedDate;
  }
  if (final !== null && final !== undefined) {
    payload.final = final;
  }
  if (status !== null && status !== undefined) {
    payload.status = status;
  }
  if (reason !== null && reason !== undefined) {
    payload.reason = reason;
  }
  if (otp !== null && otp !== undefined) {
    payload.otp = otp;
  }
  if (paymentValue !== null && paymentValue !== undefined) {
    payload.payment_value = paymentValue;
  }
  if (paymentDate !== null && paymentDate !== undefined) {
    payload.payment_date = paymentDate;
  }
  if (approveReason !== null && approveReason !== undefined) {
    payload.approval_remarks = approveReason;
  }

  return axiosInstance.post(`/orders/${orderId}/update_shipment_date`, payload);
};

export const addNewShipment = async ({ orderId, plannedDate }) => {
  return axiosInstance.post(`/orders/${orderId}/add_shipment`, { planned_date: plannedDate });
};

export const deleteShipment = async ({ orderId, shipmentId, replacementShipmentId }) => {
  const payload = { shipment_id: shipmentId };
  if (replacementShipmentId) {
    payload.replacement_shipment_id = replacementShipmentId;
  }
  return axiosInstance.post(`/orders/${orderId}/delete_shipment`, payload);
};

export const updateShipmentDescription = async ({ orderId, shipmentId, description }) => {
  return axiosInstance.post(`/orders/${orderId}/shipments/${shipmentId}/update_description`, {
    description: description || "",
  });
};

export const getShipmentInvoiceSummary = async ({ orderId, shipmentId }) => {
  return axiosInstance.get(`/orders/${orderId}/shipments/${shipmentId}/shipment_invoice_summary`, {
    params: {
      order_id: orderId,
      shipment_id: shipmentId,
    },
  });
};

export const uploadShipmentInvoice = async ({ orderId, shipmentId, invoiceFile }) => {
  const formData = new FormData();
  formData.append("invoice", invoiceFile);

  return axiosInstance.post(
    `/orders/${orderId}/shipments/${shipmentId}/upload_invoice`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const downloadShipmentInvoice = async ({ orderId, shipmentId }) => {
  const token = localStorage.getItem("accessToken");

  return axios.get(
    `${process.env.REACT_APP_API_URL}/orders/${orderId}/shipments/${shipmentId}/invoice`,
    {
      responseType: 'blob',
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );
};

export const orderPanels = async ({ orderId }) => {
  return axiosInstance.get(`/orders/${orderId}/order_panels`);
};

export const manageParts = async ({ orderId, partIds, shipmentId }) => {
  return axiosInstance.post(`/orders/${orderId}/manage_parts`, {
    part_ids: partIds,
    shipment_id: shipmentId,
  });
};

export const manageHardwares = async ({ orderId, hardwareIds, shipmentId }) => {
  return axiosInstance.post(`/orders/${orderId}/manage_hardwares`, {
    hardware_ids: hardwareIds,
    shipment_id: shipmentId,
  });
};